export const bytesToBase64=(bytes)=>{
  const binString = Array.from(bytes, (byte) =>
    String.fromCodePoint(byte),
  ).join('');
  return window.btoa(binString);
};